import { makeStyles, createStyles } from '@material-ui/core'

export const useDashboardStyle = makeStyles(
  (theme) =>
    createStyles({
      container: {
        justifyContent: 'space-between',
        alignItems: 'center',

        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          alignItems: 'flex-start'
        }
      },

      btn: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          marginTop: theme.spacing(1)
        }
      }
    }),
  {
    name: 'Dashboard'
  }
)
